module.exports = __webpack_public_path__ + "static/media/meine-routen.73f1824c.jpg";